import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface FilterStore {
  desiredWeekDay: string[]
  desiredDate?: Date
  doctorGender: string[]
  units: string[]
  shift: string[]
  scheduleFit: string[]
  resetDesiredDate: () => void
  setDesiredWeekDay: (weekday: string[]) => void
  setDesiredDate: (date?: Date) => void
  setDoctorGender: (gender: string[]) => void
  setUnits: (units: string[]) => void
  setShift: (shift: string[]) => void
  setScheduleFit: (fit: string[]) => void
  reset: () => void
}

type InitialStateStore = Pick<
  FilterStore,
  | 'desiredDate'
  | 'desiredWeekDay'
  | 'doctorGender'
  | 'units'
  | 'scheduleFit'
  | 'shift'
>

const initialState: InitialStateStore = {
  desiredDate: undefined,
  desiredWeekDay: [],
  doctorGender: [],
  units: [],
  shift: [],
  scheduleFit: []
}

export const useFilterStore = create<FilterStore>()(
  devtools(
    (set) => ({
      ...initialState,
      resetDesiredDate() {
        set({ desiredDate: undefined }, false, 'resetDesiredDate')
      },
      setDesiredWeekDay(weekday) {
        set({ desiredWeekDay: weekday }, false, 'setDesiredWeekDay')
      },
      setDesiredDate(date) {
        set({ desiredDate: date }, false, 'setDesiredDate')
      },
      setDoctorGender(gender) {
        set({ doctorGender: gender }, false, 'setDoctorGender')
      },
      setUnits(units) {
        set({ units }, false, 'setMedicalunits')
      },
      setShift(shift) {
        set({ shift })
      },
      setScheduleFit(fit) {
        set({ scheduleFit: fit })
      },
      reset: () => {
        set(initialState)
      }
    }),
    { name: 'useFilterStore' }
  )
)
